module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "header-tag": "header"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('div', {
    staticClass: "float-right"
  }, [(_vm.isHitsMode && !_vm.isAnimating && _vm.roll.edgeMode === _vm.EdgeMode.NONE) ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.html.window.hover",
      modifiers: {
        "html": true,
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "outline-warning",
      "title": "<h6>Push the Limit</h6>Spend a point of Edge to roll dice equal to your Edge, re-rolling any new sixes for extra hits, and ignore the limit."
    },
    on: {
      "click": function($event) {
        _vm.$emit('usedPushTheLimit', _vm.roll.id)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-double-up",
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHitsMode && !_vm.isAnimating && _vm.roll.edgeMode === _vm.EdgeMode.NONE) ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.html.window.hover",
      modifiers: {
        "html": true,
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "outline-warning",
      "title": "<h6>Second Chance</h6>Spend a point of Edge to re-roll dice that didn't score a hit; doesn't negate glitches."
    },
    on: {
      "click": function($event) {
        _vm.$emit('usedSecondChance', _vm.roll.id)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "redo",
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHitsMode && !_vm.isAnimating && _vm.roll.edgeMode === _vm.EdgeMode.NONE && _vm.glitchLevel > 0) ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.html.window.hover",
      modifiers: {
        "html": true,
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "outline-warning",
      "title": "<h6>Close Call</h6>Negate the effects of a glitch, or turn a critical glitch into a regular glitch."
    },
    on: {
      "click": function($event) {
        _vm.$emit('usedCloseCall', _vm.roll.id)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "tint",
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover",
      modifiers: {
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "danger",
      "title": "Delete this roll"
    },
    on: {
      "click": function($event) {
        _vm.$emit('deletedRoll', _vm.roll.id)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "times",
      "fixed-width": ""
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover.left",
      modifiers: {
        "window": true,
        "hover": true,
        "left": true
      }
    }],
    staticClass: "roll-label pt-1",
    attrs: {
      "title": _vm.date
    },
    on: {
      "mouseenter": function($event) {
        _vm.showEditIcon = true
      },
      "mouseleave": function($event) {
        _vm.showEditIcon = false
      },
      "click": _vm.startEditLabel
    }
  }, [(_vm.isEditingLabel) ? _c('span', {
    staticClass: "float-left"
  }, [_c('b-form-input', {
    ref: "labelInput",
    nativeOn: {
      "blur": function($event) {
        _vm.endEditLabel($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.endEditLabel($event)
      }
    },
    model: {
      value: (_vm.roll.label),
      callback: function($$v) {
        _vm.roll.label = $$v
      },
      expression: "roll.label"
    }
  })], 1) : _c('span', [_vm._v("\n        " + _vm._s(_vm.roll.label) + "\n        "), (_vm.showEditIcon) ? _c('span', {
    staticClass: "text-muted"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pen",
      "transform": "shrink-3 up-2"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pr-md-2",
    attrs: {
      "md": "7"
    }
  }, [_c('h1', [(_vm.isAnimating) ? _c('b-badge', {
    staticClass: "align-top text-uppercase",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n          ROLLING...\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && !_vm.isHitsMode) ? _c('b-badge', {
    staticClass: "align-top text-uppercase",
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.sum) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && _vm.isHitsMode && (_vm.totalHits > 0 || _vm.glitchLevel === 0)) ? _c('b-badge', {
    staticClass: "align-top text-uppercase",
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.limitedHits) + " " + _vm._s(_vm._f("pluralize")(_vm.limitedHits, 'hit')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && _vm.isHitsMode && _vm.glitchLevel === 1) ? _c('b-badge', {
    staticClass: "align-top text-uppercase",
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          GLITCH\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && _vm.isHitsMode && _vm.glitchLevel === 2) ? _c('b-badge', {
    staticClass: "align-top text-uppercase",
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          CRITICAL GLITCH\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dice"
  }, _vm._l((_vm.roll.dice), function(group, groupIndex) {
    return (!_vm.animate || groupIndex <= _vm.revealedGroup) ? _c('div', {
      key: groupIndex,
      staticClass: "dice-group"
    }, [(groupIndex > 0) ? _c('span', {
      staticClass: "die-plus"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": ['far', 'plus']
      }
    })], 1) : _vm._e(), _vm._l((group), function(value, dieIndex) {
      return _c('die', {
        key: dieIndex,
        attrs: {
          "frame-length": _vm.dieFrameLength,
          "no-highlight": !_vm.isHitsMode,
          "highlight-one": !(_vm.roll.edgeMode == _vm.EdgeMode.SECOND_CHANCE && groupIndex == 0),
          "highlight-six": _vm.roll.edgeMode == _vm.EdgeMode.PUSH_LIMIT_PRE || _vm.roll.edgeMode == _vm.EdgeMode.PUSH_LIMIT_POST && groupIndex > 0,
          "rolling": _vm.animate && !(groupIndex < _vm.revealedGroup || (dieIndex < _vm.revealedDie && groupIndex <= _vm.revealedGroup)),
          "value": value
        },
        on: {
          "onFrame": _vm.revealDie
        }
      })
    })], 2) : _vm._e()
  }))]), _vm._v(" "), _c('b-col', {
    staticClass: "pl-md-0",
    attrs: {
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "roll-sidebar"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Roll:")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ('Dice pool: ' + _vm.roll.dicePool + (_vm.roll.edgeMode === _vm.EdgeMode.PUSH_LIMIT_PRE ? ' + ' + _vm.roll.edge + ' from Push the Limit' : '')),
      expression: "'Dice pool: ' + roll.dicePool + (roll.edgeMode === EdgeMode.PUSH_LIMIT_PRE ? ' + ' + roll.edge + ' from Push the Limit' : '')",
      modifiers: {
        "hover": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "clone",
      "fixed-width": ""
    }
  }), _vm._v("\n          " + _vm._s(_vm.roll.dicePool) + "\n          "), (_vm.roll.edgeMode === _vm.EdgeMode.PUSH_LIMIT_PRE) ? _c('span', {
    staticClass: "text-warning"
  }, [_vm._v("\n            + " + _vm._s(_vm.roll.edge) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isHitsMode) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ('Limit: ' + (_vm.roll.limit === null ? 'None' : _vm.roll.limit) + (_vm.roll.limit ? ' (ignored)' : '')),
      expression: "'Limit: ' + (roll.limit === null ? 'None' : roll.limit) + (roll.limit ? ' (ignored)' : '')",
      modifiers: {
        "hover": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-to-top",
      "fixed-width": ""
    }
  }), _vm._v("\n          " + _vm._s((_vm.roll.limit === null || _vm.usedPushTheLimit) ? 'N/A' : _vm.roll.limit) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.isSumMode) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ('Base value: ' + _vm.roll.baseValue),
      expression: "'Base value: ' + roll.baseValue",
      modifiers: {
        "hover": true
      }
    }]
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-to-bottom",
      "fixed-width": ""
    }
  }), _vm._v("\n          " + _vm._s(_vm.roll.baseValue) + "\n        ")], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isAnimating) ? _c('span', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Result:")]), _vm._v(" "), (_vm.isHitsMode) ? _c('span', [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.getHitString(_vm.baseHits, _vm.roll.limit, _vm.roll.limit === null)),
      expression: "getHitString(baseHits, roll.limit, roll.limit === null)",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-success"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "crosshairs",
      "fixed-width": ""
    }
  }), _vm._v("\n              " + _vm._s((_vm.roll.limit !== null && _vm.baseHits > _vm.roll.limit) ? _vm.roll.limit + ' (' + _vm.baseHits + ')' : _vm.baseHits) + "\n            ")], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.getMissString(_vm.baseMisses)),
      expression: "getMissString(baseMisses)",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-danger"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "ban",
      "fixed-width": ""
    }
  }), _vm._v("\n              " + _vm._s(_vm.baseMisses) + "\n            ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.roll.edgeMode !== _vm.EdgeMode.NONE) ? _c('span', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Edge:")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.edgeModeString),
      expression: "edgeModeString",
      modifiers: {
        "hover": true
      }
    }]
  }, [(_vm.usedPushTheLimit) ? _c('span', [_c('span', {
    staticClass: "text-warning"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-double-up",
      "fixed-width": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.roll.edge) + "\n                  ")], 1), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": ['far', 'arrow-right'],
      "fixed-width": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-warning"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "bomb",
      "fixed-width": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.rerollDicePool) + "\n                  ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.roll.edgeMode === _vm.EdgeMode.SECOND_CHANCE) ? _c('span', [_c('span', {
    staticClass: "text-warning"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "redo",
      "fixed-width": ""
    }
  }), _vm._v("\n                    " + _vm._s(_vm.rerollDicePool) + "\n                  ")], 1), _vm._v(" "), (_vm.baseMisses > 0) ? _c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": ['far', 'arrow-right'],
      "fixed-width": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-warning"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "ban",
      "fixed-width": ""
    }
  }), _vm._v("\n                      -" + _vm._s(_vm.baseMisses) + "\n                    ")], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roll.edgeMode === _vm.EdgeMode.CLOSE_CALL) ? _c('span', [_c('span', {
    staticClass: "text-warning"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "tint",
      "fixed-width": ""
    }
  })], 1), _vm._v(" "), (_vm.baseMisses > 0) ? _c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": ['far', 'arrow-right'],
      "fixed-width": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-warning"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "exclamation-triangle"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "level-down"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.rollModified) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.rollModified) ? _c('span', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Final:")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.getHitString(_vm.totalHits, _vm.roll.limit, _vm.usedPushTheLimit || _vm.roll.limit === null)),
      expression: "getHitString(totalHits, roll.limit, usedPushTheLimit || roll.limit === null)",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-success"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "crosshairs",
      "fixed-width": ""
    }
  }), _vm._v("\n                " + _vm._s((_vm.roll.limit !== null && _vm.totalHits > _vm.roll.limit && !_vm.usedPushTheLimit) ? _vm.roll.limit + ' (' + _vm.totalHits + ')' : _vm.totalHits) + "\n              ")], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.getMissString(_vm.totalMisses)),
      expression: "getMissString(totalMisses)",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-danger"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "ban",
      "fixed-width": ""
    }
  }), _vm._v("\n                " + _vm._s(_vm.totalMisses) + "\n              ")], 1)]) : _vm._e()]) : _c('span', [_vm._v("\n            " + _vm._s(_vm.sum - _vm.roll.baseValue) + " + " + _vm._s(_vm.roll.baseValue) + " = "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.sum))])])]) : _c('span', [_c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Rolling...")], 1)])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71772b35!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/roller/roll-info.vue
// module id = 111
// module chunks = 2